import React, { useEffect, useRef, useState,forwardRef, useImperativeHandle } from 'react';
import {
  Box,
  Typography,
  Drawer,
  Tooltip,
  IconButton,
} from '@mui/material';
import {
  ChevronLeft,
  ChevronRight,
} from '@mui/icons-material';
import SourcePanel from './SourcePanel';
import PropTypes from 'prop-types';
// import IntegretionPanel from './IntegretionPanel';
import { useThemeContext } from '../Context/ThemeContext';
// import { setBlinkByWorkflow } from '../state/slices/mappingSlice';
import { AnimatePresence, motion } from 'framer-motion';
// import { forwardRef, useImperativeHandle } from 'react';
import sourceIcon from './images/source.png';
// import destinationIcon from './images/destination.png';
// import Integretion from './images/Integartion.png';
// import { updateWorkflowName } from '../apis/Workflows';
// import { renameWorkflow } from '../state/slices/workflowSlice';
// import { toast } from 'react-toastify';

const EXPANDED_W = 260;
const COLLAPSED_W = 64;

const Sidebar = forwardRef(
  (
    {
      // workflowId,
      clearSourceSelection,
      collapsedBoth,
      onCollapsedChange,
    },
    ref,
  ) => {
    
    // const [editField, setEditField] = useState(false);
    const { darkMode } = useThemeContext();
    // const { nodes, edges } = useSelector((state) => state.workflows);

    // const allWorkflows = useSelector((s) => s.workflows?.list || []);

    // const wf = useSelector((s) =>
    //   s.workflows?.list?.find((w) => w.workflow_id === workflowId),
    // );

    // console.log('wf:::', wf);

    // const saveBlink = useSelector(
    //   (state) => state.mapping.blinkByWorkflow?.[workflowId]?.save,
    // );

    // console.log('saveBlink:', saveBlink);

    // const handleSaveWorkflow = () => {
    //   if (workflowName.trim() === '') {
    //     alert('Please enter a workflow name.');
    //     return;
    //   }
    //   dispatch(saveWorkflow({ name: workflowName, nodes, edges }));
    //   dispatch(loadWorkflow({ name: workflowName }));
    //   alert('Workflow saved successfully.');
    //   setEditField(false);
    // };

    const [collapsed, setCollapsed] = useState(false);

    // const [editing, setEditing] = useState(false);
    // const [nameVal, setNameVal] = useState('');
    // useEffect(() => {
    //   setNameVal(wf?.name || '');
    // }, [wf?.name]);

    const srcRef = useRef(null);
    // const dstRef = useRef(null);
    // const intRef = useRef(null);
    const goExpandTo = (ref) => {
      setCollapsed(false);
      onCollapsedChange?.(false);
      setTimeout(() => ref?.current?.scrollIntoView({ behavior: 'smooth' }), 0);
    };

    useImperativeHandle(ref, () => ({
      isLeftCollapsed: collapsed,
      toggleLeftCollapsed: () => setCollapsed((v) => !v),
    }));

    // const handleClick = () => {
    //   dispatch(
    //     setBlinkByWorkflow({ workflowId, button: 'save', value: false }),
    //   );
    //   dispatch(
    //     setBlinkByWorkflow({ workflowId, button: 'execute', value: true }),
    //   );
    //   onSave();
    // };

    // const handleBack = () => {
    //   window.history.back();
    // };

    // const handleSaveName = async () => {
    //   const newName = nameVal.trim();
    //   if (!newName || !workflowId) return;

    //   const isDuplicate = allWorkflows.some(
    //     (w) => w.workflow_id !== workflowId && w.name === newName,
    //   );
    //   if (isDuplicate) {
    //     toast.error('Workflow with this name already exists.', {
    //       autoClose: 3000,
    //     });
    //     return;
    //   }

    //   if (wf?.name === newName) {
    //     setEditing(false);
    //     return;
    //   }

    //   try {
    //     await updateWorkflowName(workflowId, newName);
    //     dispatch(renameWorkflow({ workflowId, name: newName }));
    //     setEditing(false);
    //   } catch (e) {
    //     console.error('Rename failed', e);
    //   }
    // };

    useEffect(() => {
      if (typeof collapsedBoth === 'boolean') setCollapsed(collapsedBoth);
    }, [collapsedBoth]);

    const toggleBoth = () => {
      const next = !collapsed;
      setCollapsed(next);
      onCollapsedChange?.(next);
    };

    return (
      <Box>
        {/* Sidebar */}
        <Drawer
          variant="permanent"
          sx={{
            width: collapsed ? COLLAPSED_W : EXPANDED_W,
            transition: 'width 0.28s ease',
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: collapsed ? COLLAPSED_W : EXPANDED_W,
              transition: 'width 0.28s ease, padding 0.28s ease',
              boxSizing: 'border-box',
              borderRadius:'4px',
              backgroundColor: darkMode ? '#282828' : '#fff',
              color: darkMode ? '#fff' : 'inherit',
              p: collapsed ? 1 : 2,
              borderRight: `1px solid ${darkMode ? '#555' : '#ccc'}`,
              mt: 12,
              userSelect: 'none',
              WebkitUserSelect: 'none',
              MozUserSelect: 'none',
              msUserSelect: 'none',
              overflowX: 'hidden',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            {/* <IconButton size="small" onClick={() => setCollapsed((v) => !v)}> */}
            <IconButton size="small" onClick={toggleBoth}>
              {collapsed ? <ChevronRight /> : <ChevronLeft />}
            </IconButton>
          </Box>

          <AnimatePresence initial={false}>
            {!collapsed && (
              <motion.div
                initial={{ opacity: 0, y: -4 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -4 }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    marginTop: 2,
                    color: darkMode ? '#fff' : 'inherit',
                  }}
                >
                  Components
                </Typography>
              </motion.div>
            )}
          </AnimatePresence>

          <AnimatePresence initial={false} mode="popLayout">
            {collapsed ? (
              <motion.div
                key="icons"
                initial={{ opacity: 0, x: -8 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -8 }}
                transition={{ duration: 0.2 }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1.5,
                    mt: 1,
                  }}
                >
                  <Tooltip title="Source" placement="right">
                    <IconButton onClick={() => goExpandTo(srcRef)}>
                      <img
                        src={sourceIcon}
                        alt="Source"
                        width={24}
                        height={24}
                      />
                    </IconButton>
                  </Tooltip>
                  {/* <Tooltip title="Destination" placement="right">
                  <IconButton onClick={() => goExpandTo(dstRef)}>
                    <img
                      src={destinationIcon}
                      alt="Destination"
                      width={24}
                      height={24}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Integrations" placement="right">
                  <IconButton onClick={() => goExpandTo(intRef)}>
                    <img
                      src={Integretion}
                      alt="Integration"
                      width={24}
                      height={24}
                    />
                  </IconButton>
                </Tooltip> */}
                </Box>
              </motion.div>
            ) : (
              <motion.div
                key="panels"
                initial={{ opacity: 0, x: -12 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -12 }}
                transition={{ duration: 0.25 }}
              >
                <Box
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    mt: 2,
                    pb: 10,
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#C5CEEA transparent',

                    '&::-webkit-scrollbar': { width: 6 },
                    '&::-webkit-scrollbar-track': { background: 'transparent' },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#C5CEEA',
                      borderRadius: 8,
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#9BACDD',
                    },
                  }}
                >
                  <div ref={srcRef}>
                    <SourcePanel clearTrigger={clearSourceSelection} />
                  </div>
                  {/* <div ref={dstRef}>
                  <DestinationPanel />
                </div> */}
                  {/* <div ref={intRef}>
              <IntegretionPanel />
            </div> */}
                </Box>
              </motion.div>
            )}
          </AnimatePresence>
        </Drawer>
      </Box>
    );
  },
);

Sidebar.propTypes = {
  workflowId: PropTypes.string,
  onSave: PropTypes.func,
  clearSourceSelection: PropTypes.number,
  collapsedBoth: PropTypes.bool,
  onCollapsedChange: PropTypes.func,
};

Sidebar.displayName = 'Sidebar';
export default Sidebar;
